import BaseBehavior from '../../../framework/base/base';
import rowColumnAnimation from './row-column-animation';

export default class TableAnimation extends BaseBehavior {
	constructor(element) {
		super(element);
		rowColumnAnimation.setupAnimation(this.element);
	}
}
